import { Button, Card, Modal } from '@playerbase/ui';

// Inverse of dismiss-pattern-confirm-modal. Confirmation step for
// bringing a dismissed pattern back into the four buckets.

interface RestorePatternConfirmModalProps {
  open: boolean;
  patternTitle: string;
  patternId: string;
  busy: boolean;
  error: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export function RestorePatternConfirmModal({
  open,
  patternTitle,
  patternId,
  busy,
  error,
  onConfirm,
  onCancel,
}: RestorePatternConfirmModalProps): JSX.Element {
  const labelId = `restore-pattern-${patternId}`;
  return (
    <Modal
      open={open}
      onClose={onCancel}
      labelledById={labelId}
      busy={busy}
      size="sm"
    >
      <Card>
        <Card.Header>
          <Card.Title id={labelId}>Restore pattern</Card.Title>
          <Card.Description>
            Bring <strong>{patternTitle}</strong> back into the four buckets?
            It will reappear in its current bucket.
          </Card.Description>
        </Card.Header>
        {error !== null && (
          <Card.Content>
            <p className="text-sm text-danger-text">{error}</p>
          </Card.Content>
        )}
        <Card.Footer>
          <Button variant="ghost" onClick={onCancel} disabled={busy}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onConfirm} disabled={busy}>
            {busy ? 'Restoring…' : 'Restore pattern'}
          </Button>
        </Card.Footer>
      </Card>
    </Modal>
  );
}
